import React, { ChangeEvent, ReactNode } from 'react';

import { CmFormControl, CmFormLabel, CmUpload } from '@/components/uiParts';

interface Props {
  error?: ReactNode;
  isDisabledDeleteButton?: boolean;
  id?: string;
  label: string;
  width?: string;
  src?: string;
  accept?: string;
  isRequired?: boolean;
  fontWeight?: 'normal' | 'bold';
  isInvalid?: boolean;
  children?: ReactNode;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  onClear?: () => void;
  onDelete?: () => void;
}

export const CmLabelAndUpload: React.FC<Props> = ({
  id = '',
  isDisabledDeleteButton = false,
  label,
  width = '100%',
  src,
  accept,
  isInvalid = false,
  isRequired = false,
  fontWeight = 'normal',
  onChange,
  onClear,
  onDelete,
  error,
  children,
}) => {
  return (
    <CmFormControl {...{ width, isInvalid }}>
      <CmFormLabel
        htmlFor={id}
        {...{ isRequired, fontWeight }}
        width="fit-content"
      >
        {label}
      </CmFormLabel>
      <CmUpload
        {...{
          onChange,
          onClear,
          onDelete,
          isDisabledDeleteButton,
          src,
          id,
          accept,
        }}
      />
      {children}
      {error}
    </CmFormControl>
  );
};
